export const authErrorMessage = Object.freeze({
  EMAIL_IN_USE: 'Email already in use',
  USERNAME_TAKEN: 'Username taken',
  WRONG_PASSWORD: 'Incorrect Email or Password',
  USER_NOT_FOUND: 'No user found ',
});
